module.exports = __webpack_public_path__ + "img/item4.c415a0b5.png";